import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

/**
 * Custom hook to access authentication context.
 * Returns user, loading state, signIn, signOut, and error handling.
 *
 * @throws {Error} If used outside of AuthProvider
 * @returns Authentication context with user data and auth methods
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
